export default __webpack_public_path__ + "static/14_Kyon-52e62538a056a1b78304d0cb7cb165de.pdf";